var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorShipSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16593_45737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1732 3.75139C16.0138 2.91074 16.144 2.13957 16.7546 1.36248C17.2326 0.754173 18.1378 0.754173 18.6157 1.36248C19.2265 2.13957 19.3566 2.91074 20.1972 3.75139C21.0378 4.59203 21.8091 4.72214 22.5862 5.33282C23.1944 5.81087 23.1944 6.71592 22.5862 7.19395C21.8091 7.80465 21.0378 7.93478 20.1973 8.7754C19.3566 9.61605 19.2265 10.3872 18.6159 11.1643C18.1378 11.7726 17.2328 11.7726 16.7547 11.1643C16.144 10.3872 16.0139 9.61605 15.1733 8.7754C14.3326 7.93476 13.5615 7.80465 12.7843 7.19395C12.1761 6.71592 12.1761 5.81087 12.7843 5.33282C13.5615 4.72214 14.3326 4.59201 15.1732 3.75139Z",
    stroke: "#5B4200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65129 5.77344C7.42398 5.8147 6.21692 5.93153 5.03521 6.06325C3.04928 6.2846 1.45123 7.88266 1.23866 9.86955C1.08173 11.3363 0.949219 12.8422 0.949219 14.3774C0.949219 15.9126 1.08173 17.4185 1.23866 18.8852C1.45123 20.8721 3.04928 22.4702 5.03521 22.6915C6.51029 22.8559 8.02482 22.9971 9.56898 22.9971C11.1131 22.9971 12.6277 22.8559 14.1028 22.6915C16.0887 22.4702 17.6868 20.8721 17.8993 18.8852C18.0341 17.6251 18.151 16.3362 18.1812 15.0246",
    stroke: "#5B4200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56756 22.9991C8.0234 22.9991 6.50887 22.8579 5.03377 22.6935C4.80324 22.6678 4.57791 22.6235 4.35938 22.5623C4.61266 21.3874 5.29116 20.2342 6.21994 19.4751C7.16458 18.703 8.34711 18.2812 9.56715 18.2812C10.7872 18.2812 11.9697 18.703 12.9144 19.4751C13.859 20.2472 14.5077 21.3222 14.7505 22.5178C14.7505 22.5178 14.7498 22.537 14.7494 22.5695C14.5391 22.6271 14.3226 22.6688 14.1014 22.6935C12.6263 22.8579 11.1117 22.9991 9.56756 22.9991Z",
    stroke: "#5B4200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5568 15.5823C11.3307 15.5823 12.3284 14.5845 12.3284 12.8107C12.3284 11.0368 11.3307 10.0391 9.5568 10.0391C7.78296 10.0391 6.78516 11.0368 6.78516 12.8107C6.78516 14.5845 7.78296 15.5823 9.5568 15.5823Z",
    stroke: "#5B4200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16593_45737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorShipSelect);
export default __webpack_public_path__ + "static/media/MentorShipSelect.0b5250b8a4232fd177e876ee39f847e1.svg";
export { ForwardRef as ReactComponent };